export const teacherAttendance= [
    {
        
        id: "TCH0001",
        name: "Janet",
        class: "Year 3, Jupiter",
        notes: "",
        img : "assets/img/students/student-01.jpg",
        attendance:"",
        key:1
      },
      {
        
        id: "TCH0002",
        name: "Daniel",
        class: "Year 2, Mars",
        notes: "",
        img : "assets/img/students/student-02.jpg",
        attendance:"",
        key:2
      },
      {
        
        id: "TCH0003",
        name: "Hellana",
        class: "Year 6, Jupiter",
        notes: "",
        img : "assets/img/students/student-03.jpg",
        attendance:"",
        key:3
      },
      {
        
        id: "TCH0004",
        name: "Erickson",
        class: "Year 6, Mars & Year 5, Jupiter)",
        notes: "",
         img : "assets/img/students/student-04.jpg",
         attendance:"",
         key:4
      },
      {
        
        id: "TCH0005",
        name: "Morgan",
        class: "Year 8, Saturn",
        notes: "",
        img : "assets/img/students/student-05.jpg",
        attendance:"",
        key:5
      },
      {
        
        id: "TCH0006",
        name: "Aaron",
        class: "Year 1, Jupiter",
        notes: "",
        img : "assets/img/students/student-06.jpg",
        attendance:"",
        key:6
      },
      {
        
        id: "TCH0007",
        name: "Jacquelin",
        class: "Year 4, Mars",
        notes: "",
        img : "assets/img/students/student-07.jpg",
        attendance:"",
        key:7
      },
      {
        
        id: "TCH00008",
        name: "Raul",
        class: "Year 9, Saturn",
        notes: "",
         img : "assets/img/students/student-08.jpg",
         attendance:"",
         key:8
      },
      {
        
        id: "TCH0009",
        name: "Elizabeth",
        class: "Year 7, Jupiter",
        notes: "",
        img : "assets/img/students/student-09.jpg",
        attendance:"",
        key:9
      },
      {
        
        id: "TCH0010",
        name: "Edward",
        class: "Year 9, Saturn & Year 10, Saturn",
        notes: "",
        img : "assets/img/students/student-07.jpg",
        attendance:"",
        key:10
      }
];
